import { Injectable } from '@angular/core';

import { DataService } from '../../../Services/Data/data.service';

@Injectable()
export class TemplatesService {
  root_folder: any = [];
  documents: any = [];
  constructor(private dataService: DataService) {}

  // Get all templates from the API
  getAllTemplates() {
    return this.dataService.apiGetCall('/api/templates');
  }

  // Get all folders from the API
  getFolders() {
    return this.dataService.apiGetCall('/api/folders');
  }

  getClonedDocumentFromTemplate(id) {
    return this.dataService.apiGetCall('/api/generate_document_from_template?template_id=' + id);
  }
}
